<template>
  <b-row class="pre-ordenafrase-activity">
    <b-col lg="12">
            <p>
                <strong>INSTRUCCIONES:</strong>
            </p>
            <p>{{data.instrucciones}}</p>
        </b-col>

<div id="app">
            <div id="board">
      <canvas id="board-canvas" width="700" height="311"></canvas>
    </div>

    <!-- row of blank letters for the selected word -->

    <div id="word">
      <div class="word-blankletter" v-for="letter in wordDivs" v-cloak>{{ letter }}</div>
    </div>

    <!-- keyboard -->
    <div id="keyboard">
      <div v-for="row in letters" class="keyboard-row">
        <letter-button v-for="letter in row" :letter="letter" :game-over="gameOver" :two-players="twoPlayers" :key="letter" @check="check(letter)" v-cloak></letter-button>
      </div>
    </div>

    <!-- 'one player' 'play again' 'two players' -->
    <div id="buttons">
      <button class="buttons-button" :class="{ orange: !twoPlayers }" @click="onePlayer">Un jugador</button>
      <button id="playagain" class="buttons-button" :class="{ hidden: !gameOver }" @click="playAgain">Jugar de nuevo</button>
      <button class="buttons-button" :class="{ orange: twoPlayers }" @click="twoPlayer">Dos Jugadores</button>
    </div>
  </div>
</b-row>
</template>

<script>
function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
import OptionsElement from '@/components/constructor/OptionsElement';
import LetterButton from '@/components/constructor/LetterButton';
export default {
  name: "pre-hangman",
   props: {
      data: {
        type: Object,
        default: () => {
          return {
            index: null,
            tag: 'HangMan',
            palabras: [],
            instrucciones: '',
            palabra: ''
          }
        }
      }
  },
  data() {
    return {
       letters: [
          ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
          ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
          ["Z", "X", "C", "V", "B", "N", "M"]
        ],
        words: [
          "CAT", 
          "BIRD", 
          "FLOWER", 
          "TABLE", 
          "DOG", 
          "POLICE", 
          "CHURCH", 
          "CLOCK", 
          "PEN", 
          "BLUE",
          "GRAPES", 
          "YELLOW",
          "LION",
          "APPLE",
          "BANANA",
          "CAKE",
          "CHICKEN",
          "PENCIL"
        ],
        currentWord: "",
        // each element in this array is a letter in the word
        wordDivs: [],
        // to count the number of wrong guesses
        guesses: 0,
        gameOver: false,
        lose: false,
        twoPlayers: false,
        // will be set to the canvas element in mounted()
        canvas: "",
        // will be set to the canvas 2d context
        ctx: ""
      };
    },
  components: {
    OptionsElement,
    'letter-button':LetterButton
  },
  methods: {
     
        drawGallows: function(ctx) {
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ctx.fillStyle = "#FF9800";
      ctx.strokeStyle = "#FF9800";
      ctx.beginPath();
      // left side
      ctx.moveTo(this.canvas.width / 10, this.canvas.height / 10);
      ctx.lineTo(this.canvas.width / 10, this.canvas.height * 0.95);
      // bottom side
      ctx.lineTo(this.canvas.width * 0.8, this.canvas.height * 0.95);
      // top side
      ctx.moveTo(this.canvas.width / 10, this.canvas.height / 10);
      ctx.lineTo(this.canvas.width * 0.4, this.canvas.height / 10);
      // hanging notch
      ctx.lineTo(this.canvas.width * 0.4, this.canvas.height / 5);
      ctx.stroke();
      ctx.closePath();
    },
    // fill this.wordDivs with empty strings to create the orange blanks
    makeBlanks: function() {
      for (var i = 0; i < this.currentWord.length; i++) {
        this.wordDivs.push("");
      }
    },
    // draws the appropriate part of the hanging man and/or 'game over'
    updateCanvas: function(ctx) {
      // this.drawGallows(ctx);
      // draw the head
      if (this.guesses === 0) {
        ctx.beginPath();
        ctx.arc(this.canvas.width * 0.4, (this.canvas.height / 5) + 20, 20, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.closePath();
      } 
      // draw the torso
      else if (this.guesses === 1) {
        ctx.beginPath();
        ctx.moveTo(this.canvas.width * 0.4, (this.canvas.height / 5) + 40);
        ctx.lineTo(this.canvas.width * 0.4, this.canvas.height / 2);
        ctx.stroke();
        ctx.closePath();
      }
      // draw the right leg
      else if (this.guesses === 2) {
        ctx.beginPath();
        ctx.moveTo(this.canvas.width * 0.4, this.canvas.height / 2);
        ctx.lineTo((this.canvas.width * 0.4) + 30, this.canvas.height * 0.7);
        ctx.stroke();
        ctx.closePath();
      }
      // draw the left leg
      else if (this.guesses === 3) {
        ctx.beginPath();
        ctx.moveTo(this.canvas.width * 0.4, this.canvas.height / 2);
        ctx.lineTo((this.canvas.width * 0.4) - 30, this.canvas.height * 0.7);
        ctx.stroke();
        ctx.closePath();
      }
      // draw the right arm
      else if (this.guesses === 4) {
        ctx.beginPath();
        ctx.moveTo(this.canvas.width * 0.4, (this.canvas.height / 5) + 55);
        ctx.lineTo((this.canvas.width * 0.4) + 35, (this.canvas.height / 2) + 10);
        ctx.stroke();
        ctx.closePath();
      } 
      // draw the left arm and handle game over
      else if (this.guesses === 5) {
        ctx.beginPath();
        ctx.moveTo(this.canvas.width * 0.4, (this.canvas.height / 5) + 55);
        ctx.lineTo((this.canvas.width * 0.4) - 35, (this.canvas.height / 2) + 10);
        ctx.stroke();
        ctx.closePath();
        // game over
        ctx.font = "24px Roboto, sans-serif";
        ctx.fillText("Juego Terminado", this.canvas.width * 0.4 - 30, this.canvas.height * 0.9);
        this.gameOver = true;
        this.lose = true;
        // fill in the word with the correct answer
        for (var i = 0; i < this.currentWord.length; i++) {
          this.$set(this.wordDivs, i, this.currentWord[i]);
        }
      }
      this.guesses++
    },
    // check the chosen letter when a letter component emits 'check'
    check: function(letter) {
      if (!this.gameOver) {
        var guessCorrect = false;
        // check if the letter is in the word, if so, fill it in
        for (var i = 0; i < this.currentWord.length; i++) {
          if (letter == this.currentWord[i]) {
            this.$set(this.wordDivs, i, letter);
            guessCorrect = true;
          }
        }
        // if there are no more blanks in the word, you win
        if (!this.wordDivs.some(function(value) {return value == ""})) {
          this.gameOver = true;
          this.ctx.font = "24px Roboto, sans-serif";
          this.ctx.fillText("Ganaste!", this.canvas.width * 0.4 - 30, this.canvas.height * 0.9);
        }
        // if they guess wrong, draw the man
        if (!guessCorrect) {
          this.updateCanvas(this.ctx);
        }
      }
    },
    // re-initializes the game
    restart: function() {
      this.gameOver = false;
      this.lose = false;
      this.guesses = 0;
      this.wordDivs.splice(0);
      this.drawGallows(this.ctx);
      this.makeBlanks();
    },
    // resets the game to one-player mode and chooses a new word
    onePlayer: function() {
      if (this.twoPlayers) {
        this.twoPlayers = false;
        this.currentWord = this.words[randomInteger(0, this.words.length - 1)];
        this.restart();
      }
    },
    // starts two-player mode and prompts the user to enter a word
    twoPlayer: function() {
      if (!this.twoPlayers) {
        this.gameOver = true;
        this.twoPlayers = true;
        this.wordDivs.splice(0);
        try {
          this.currentWord = prompt("Ingresa una palabra!").toUpperCase();
        }
        catch(e) {
          this.onePlayer();
          return;
        }
        var letters = /^[A-Za-z]+$/;
        while (!letters.test(this.currentWord)) {
          try {
            this.currentWord = prompt("Unicamente letras! Ingresa una palabra:").toUpperCase();
          }
          catch(e) {
            this.onePlayer();
            return;
          }
        }
        this.restart();
      }
    },
    // chooses a new word and resets the game when 'play again' is clicked
    playAgain: function() {
      if (this.twoPlayers) {
        try {
          this.currentWord = prompt("Ingresa una palabra!").toUpperCase();
        }
        catch(e) {
          this.onePlayer();
          return;
        }
        var letters = /^[A-Za-z]+$/;
        while (!letters.test(this.currentWord)) {
          try {
            this.currentWord = prompt("Unicamente letras! Ingresa una palabra:").toUpperCase();
          }
          catch(e) {
            this.onePlayer();
            return;
          }
        }
      }
      else {
        this.currentWord = this.words[randomInteger(0, this.words.length - 1)];
      }
      this.restart();
    }
  },
  watch: {
    
  },
  mounted: function() {
    console.log(this.data.palabras);
    this.canvas = document.getElementById("board-canvas");
    this.canvas.width = document.getElementById("board").offsetWidth;
    this.canvas.height = document.getElementById("board").offsetHeight;
    this.ctx = this.canvas.getContext("2d");
    this.ctx.lineWidth = 2;
    this.drawGallows(this.ctx);
    this.currentWord = this.words[randomInteger(0, this.words.length - 1)];
    this.makeBlanks();
  }
};
</script>
<style scoped>
.pre-ordenafrase-activity{
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #ceebf0;
    border-radius: .5rem;
    border: solid #63c2de .1rem;
    padding-top: 10px;
    padding-bottom: 10px;
}


button {
  background-color: white;
  border: none;
  color: #333;
  box-shadow: 0 2px 5px #D0D0D0;
  font-family: 'Roboto', sans-serif;
  margin: 2px;
}

button:disabled {
  color: #CCC;
}

/* II. helper classes applied by js */
.hidden {
  display: none;
}

.orange {
  background-color: #ff9800;
}

/* III. the app and its contents */
#app {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0;
  width: 100%;
}

  /* A. title bar / header */
  #header {
    align-items: center;
    background-color: #007C91;
    display: flex;
    height: 40px;
    justify-content: space-between;
    width: 100%;
  }

    #header-title {
      color: white;
      font-size: 1.75em;
      font-weight: 300;
      margin: 0 0 0 10px;
    }

    #header-github {
      height: 32px;
      margin: 0 10px 0 0;
      width: 32px;
    }

      #header-github-img {
        height: 100%;
        width: 100%;
      }

  /* B. canvas container */
  #board {
    background-color: #ceebf0;
    flex: 2 1 auto;
    margin: 50px 0 0 0;
    max-width: 700px;
    width: 95%;
  }

  /* C. blank letters */
  #word {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 20px 0 18px 0;
  }

    .word-blankletter {
      align-items: flex-end;
      background-color: #ff9800;
      box-shadow: 0 2px 5px #D0D0D0;
      display: flex;
      height: 30px;
      justify-content: center;
      margin: 0 2px 2px 2px;
      width: 20px;
    }

  /* D. keyboard */
  #keyboard {
    align-items: center;
    display: flex;
    flex: 2 1 auto;
    flex-direction: column;
  }

    .keyboard-row {
      display: flex;
    }

      .keyboard-row-letter {
        height: 40px;
        width: 28px;
      }

  /* E. game-option buttons */
  #buttons {
    display: flex;
    justify-content: space-between;
    margin: 0 0 5px 0;
    max-width: 700px;
    width: 95%;
  }

    .buttons-button {
      height: 25px;
      font-size: 1em;
    }
</style>